export var COMMON_TYPES;
(function (COMMON_TYPES) {
    COMMON_TYPES["NAVIGATE_STEPS"] = "NAVIGATE_STEPS";
    COMMON_TYPES["RESET_STATE"] = "RESET_STATE";
    COMMON_TYPES["SAVE_CARD_DETAILS"] = "SAVE_CARD_DETAILS";
    COMMON_TYPES["SELECT_DEV_PLAN"] = "SELECT_DEV_PLAN";
    COMMON_TYPES["SET_DEV_PLAN_INTERVAL"] = "SET_DEV_PLAN_INTERVAL";
    COMMON_TYPES["SET_EMAIL_VERIFICATION_DATA"] = "SET_EMAIL_VERIFICATION_DATA";
    COMMON_TYPES["SET_DEV_PLAN_TRIAL"] = "SET_DEV_PLAN_TRIAL";
    COMMON_TYPES["SHOULD_HOLD"] = "SHOULD_HOLD";
})(COMMON_TYPES || (COMMON_TYPES = {}));
export var DEV_PLAN_INTERVAL;
(function (DEV_PLAN_INTERVAL) {
    DEV_PLAN_INTERVAL["MONTHLY"] = "month";
    DEV_PLAN_INTERVAL["ANNUALLY"] = "year";
})(DEV_PLAN_INTERVAL || (DEV_PLAN_INTERVAL = {}));
export var GET_DEV_PLAN_TYPES;
(function (GET_DEV_PLAN_TYPES) {
    GET_DEV_PLAN_TYPES["FAILURE"] = "GET_DEV_PLAN_FAILURE";
    GET_DEV_PLAN_TYPES["REQUEST"] = "GET_DEV_PLAN_REQUEST";
    GET_DEV_PLAN_TYPES["SUCCESS"] = "GET_DEV_PLAN_SUCCESS";
})(GET_DEV_PLAN_TYPES || (GET_DEV_PLAN_TYPES = {}));
export var PURCHASE_DEV_PLAN_TYPES;
(function (PURCHASE_DEV_PLAN_TYPES) {
    PURCHASE_DEV_PLAN_TYPES["REQUEST"] = "PURCHASE_DEV_PLAN_REQUEST";
    PURCHASE_DEV_PLAN_TYPES["SUCCESS"] = "PURCHASE_DEV_PLAN_SUCCESS";
    PURCHASE_DEV_PLAN_TYPES["FAILURE"] = "PURCHASE_DEV_PLAN_FAILURE";
})(PURCHASE_DEV_PLAN_TYPES || (PURCHASE_DEV_PLAN_TYPES = {}));
export var SEND_EMAIL_VERIFICATION_TYPES;
(function (SEND_EMAIL_VERIFICATION_TYPES) {
    SEND_EMAIL_VERIFICATION_TYPES["REQUEST"] = "SEND_EMAIL_VERIFICATION_REQUEST";
    SEND_EMAIL_VERIFICATION_TYPES["SUCCESS"] = "SEND_EMAIL_VERIFICATION_SUCCESS";
    SEND_EMAIL_VERIFICATION_TYPES["FAILURE"] = "SEND_EMAIL_VERIFICATION_FAILURE";
})(SEND_EMAIL_VERIFICATION_TYPES || (SEND_EMAIL_VERIFICATION_TYPES = {}));
export var VERIFY_EMAIL_TYPES;
(function (VERIFY_EMAIL_TYPES) {
    VERIFY_EMAIL_TYPES["FAILURE"] = "VERIFY_EMAIL_FAILURE";
    VERIFY_EMAIL_TYPES["REQUEST"] = "VERIFY_EMAIL_REQUEST";
    VERIFY_EMAIL_TYPES["SUCCESS"] = "VERIFY_EMAIL_SUCCESS";
})(VERIFY_EMAIL_TYPES || (VERIFY_EMAIL_TYPES = {}));
export var NAVIGATE_STEP_KEYS;
(function (NAVIGATE_STEP_KEYS) {
    NAVIGATE_STEP_KEYS["START"] = "start";
    NAVIGATE_STEP_KEYS["EMAIL_VERIFICATION"] = "emailVerification";
    NAVIGATE_STEP_KEYS["DEV_PLAN_SELECTION"] = "devPlanSelection";
    NAVIGATE_STEP_KEYS["CARD_DETAILS"] = "cardDetails";
    NAVIGATE_STEP_KEYS["SUCCESS"] = "success";
})(NAVIGATE_STEP_KEYS || (NAVIGATE_STEP_KEYS = {}));
